import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import TextField from 'shared/components/text-field/TextField';
import SelectDropdown from 'shared/components/select-dropdown/SelectDropdown';
import Button from 'shared/components/button/Button';
import Datepicker from 'shared/components/datepicker/datepicker';
import NumberFormatField from 'shared/components/numberFormatField/NumberFormatField';

const GoalStrengthAdd = ({ setModalOpen, openModal, errors, setFieldValue, goal, exercises, values, setFieldTouched }) => {
  const fieldsNames = ['type', 'due_date', 'exercise', 'exercise_name', 'max_lift', 'description', 'goal', 'goal_unit'];
  const [performanceType, setPerformanceType] = useState();
  const [dueDate, setDueDate] = useState();

  useEffect(() => {
    setPerformanceType(goal?.type ? goal.type : '')
    setDueDate(goal?.due_date ? goal.due_date : '')
  }, [goal])


  const types = [
    {
      value: "Other",
      option: "Other"
    },
    {
      value: "Strength",
      option: "Strength"
    }
  ];

  const makeFieldsTouched = () => {
    setFieldTouched('type');
    setFieldTouched('due_date');
    if(values.type && values.type === 'Strength'){
      setFieldTouched('exercise');
      setFieldTouched('max_lift');
    } else {
      setFieldTouched('description');
      setFieldTouched('goal_unit');
      setFieldTouched('goal');
    }
  }

  return (
    <div>
      <Modal isOpen={openModal} className="goal-add-modal">
        <ModalHeader>
          <span>Add Performance Goal</span>
          <a className="modal-close" onClick={() => {
            fieldsNames.forEach((name) => {
              setFieldValue(name, goal[name])
            })
            setModalOpen(false)
            }
          }>
            Close
          </a>
        </ModalHeader>
        <ModalBody>
          
          {
          performanceType === 'Strength' ?
            /* When strength is selected */
          (
            <div>
              <div className="form-row">
                <div className="col">
                  <SelectDropdown
                    name="type"
                    options={types}
                    label="Type"
                    handleChange={
                      (fieldName, value) => {
                        setPerformanceType(value)
                        setFieldValue(fieldName, value)
                      }
                    }
                  />
                </div>
                <div className="col">
                  <SelectDropdown
                    name="exercise"
                    options={exercises}
                    label="Exercise"
                    handleChange={
                      (fieldName, value) => {
                        setFieldValue(
                          'exercise_name',
                          exercises
                          .filter(exercise => exercise.value === value)
                          .map(element => element.option)[0]
                        )
                      }
                    }
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="col">
                  <NumberFormatField
                    name="max_lift"
                    label="Max Lift"
                    placeholder="Max Lift"
                    allowNegative={false}
                    isAllowed={true}
                  />
                </div>
                <div className="col">
                  <Datepicker
                    name="due_date"
                    label="Due Date"
                    selected={dueDate}
                    onChange={date => {
                      setDueDate(date)
                      setFieldValue('due_date', date)
                    }}
                  />
                </div>
              </div>
            </div>
          ) : performanceType === 'Other' ?
          (
            /* When other is selected */
              <div>
                <div className="form-row">
                  <div className="col">
                    <SelectDropdown
                      name="type"
                      options={types}
                      label="Type"
                      handleChange={
                        (fieldName, value) => {
                          setPerformanceType(value)
                          setFieldValue(fieldName, value)
                        }
                      }
                    />
                  </div>
                  <div className="col">
                    <TextField
                      type="text"
                      name="description"
                      label="Describe the Goal"
                      placeholder="eg: walk 10 km"
                    />
                  </div>
                </div>
                <div className="form-row">
                  <div className="col">
                    <TextField
                      type="text"
                      name="goal_unit"
                      label="Goal Units"
                      placeholder="eg: mins"
                    />
                  </div>
                  <div className="col">
                    <NumberFormatField
                      name="goal"
                      label="Goal"
                      placeholder="eg in 10"
                      allowNegative={false}
                      isAllowed={true}
                    />
                  </div>
                </div>
                <div className="form-row">
                  <div className="col">
                    <Datepicker
                      name="due_date"
                      label="Due Date"
                      selected={dueDate}
                      onChange={date => {
                        setDueDate(date)
                        setFieldValue('due_date', date)
                      }}
                    />
                  </div>
                  <div className="col"></div>
                </div>
              </div>
            ) : (
              <div>
                <div className="form-row">
                  <div className="col">
                    <SelectDropdown
                      name="type"
                      options={types}
                      label="Type"
                      handleChange={
                        (fieldName, value) => {
                          setPerformanceType(value)
                          setFieldValue(fieldName, value)
                        }
                      }
                    />
                  </div>
                  <div className="col"></div>
                </div>
              </div>
            )
          }
          <div className="form-action">
            <Button
              id=""
              type="submit"
              btnBlock=""
              btnSize=""
              color="primary"
              label="Save Goal"
              onClick={() => {
                let { strengthMod, type, due_date, goal, goal_unit, description, exercise,
                  exercise_name, max_lift } = errors;
                if (
                  values.type && ! type && !strengthMod &&
                  ((values.type === "Other" && !due_date && !goal && !goal_unit && !description)
                    ||
                  (values.type === "Strength" && !exercise && !exercise_name && !max_lift && !due_date))
                ) {
                  setModalOpen(false);
                } else {
                  makeFieldsTouched();
                }
              }}
            />
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
}

export default GoalStrengthAdd;
